/*
  This component specifies options for a ResponsiveBook
  that is rendered in a similar/related books context.

  CommunityRating options, description, and WTR button are included.

  Ref: https://w.amazon.com/bin/view/Goodreads/Teams/Mobile_web/Responsive_SeriesList_Components_Refactor/
*/

import { PropTypes } from "react";
import GrPropTypes from "../shared/gr_prop_types";
import ResponsiveBook from "../responsive_book";

const SimilarBook = ({ book, readOnlyStars }) => {

  const communityRatingOptions = { displayRating: true,
                                   displayAvgRatingText: true,
                                   displayRatingsCount: true,
                                   displayTextReviewsCount: false,
                                   displayPublicationDate: false,
                                   displayEditionsCount: false };

  return(
    <ResponsiveBook book={book}
                    communityRatingOptions={communityRatingOptions}
                    includeDescription={true}
                    includeWTRButton={true}
                    readOnlyStars={readOnlyStars} />
  );
};

SimilarBook.propTypes = {
  book: GrPropTypes.book({
    avgRating: PropTypes.number.isRequired,
    ratingsCount: PropTypes.number.isRequired,
  }).isRequired,
  readOnlyStars: PropTypes.bool,
};

SimilarBook.defaultProps = {
  readOnlyStars: false,
};

export default SimilarBook;
